export default __webpack_public_path__ + "static/media/Screenshot_17.9b92154b.png";